<template>
  <div id="dice-wrap">
    <h3>Dice</h3>
    <div class="dice-types">
      <button
        class="display-die"
        v-for="die in diceTypes"
        :key="die.label"
        @click="addToLineup(die)"
      >{{ die.label }}</button>
    </div>
    <h3>Modifier</h3>
    <div class="dice-modifiers">
      <button
        class="display-mod"
        v-for="mod in modifiers"
        :key="mod"
        :id="mod === currentMod ? 'selected-dice-mod' : ''"
        @click="setModifier(mod)"
      >{{ mod > 0 ? '+' + mod : mod }}</button>
    </div>
    <div class="lineup">
      <span
        v-for="(die, index) in diceLineup"
        :key="index"
      >{{ die.label }}{{ index === diceLineup.length - 1 ? '' : ' + ' }}</span>
      <span>{{ currentMod === 0 ? '' : currentMod > 0 ? ' +' + currentMod : ' ' + currentMod}}</span>
    </div>
    <button class="roll-dice" @click="rollDice">{{ rollResult }}</button>
  </div>
</template>

<script>
// (Roll and add enhancements) (Be sure to have all types: d4, d6, d8, d10, d12, d20)
export default {
  name: "Dice",
  components: {},
  data() {
    return {
      diceTypes: [
        { label: "d4", value: 4 },
        { label: "d6", value: 6 },
        { label: "d8", value: 8 },
        { label: "d10", value: 10 },
        { label: "d12", value: 12 },
        { label: "d20", value: 20 },
        { label: "C", value: -1 },
        { label: "-", value: 0 }
      ],
      modifiers: [-3, -2, -1, 0, 1, 2, 3],
      currentMod: 0,
      diceLineup: [],
      rollResult: "Roll"
    };
  },
  methods: {
    addToLineup: function(die) {
      if (this.rollResult !== "Roll") {
        this.diceLineup = [];
        this.rollResult = "Roll";
      }

      if (die.value === -1) {
        this.diceLineup = [];
      } else if (die.label === "-") {
        this.diceLineup.pop();
      } else {
        this.diceLineup.push(Object.assign({}, die));
      }
    },
    setModifier: function(mod) {
      if (this.rollResult !== "Roll") {
        this.diceLineup = [];
        this.rollResult = "Roll";
      }
      this.currentMod = mod;
    },
    rollDice: async function() {
      if (this.diceLineup.length == 0) {
        return;
      }

      if (this.rollResult !== "Roll") {
        this.diceLineup = [];
        this.rollResult = "Roll";
        return;
      }

      let result = this.currentMod;
      for (let i = 0; i < this.diceLineup.length; i++) {
        let bound = this.diceLineup[i].value;
        for (let j = 0; j < this.generateRandomNumber(8, 18); j++) {
          let rand = this.generateRandomNumber(0, bound);
          this.diceLineup[i].label = "" + rand;
          this.diceLineup[i].value = rand;
          await this.sleep(50);
        }
        result += this.diceLineup[i].value;
      }
      this.rollResult = result;
    },
    generateRandomNumber: function(lower, upper) {
      return Math.ceil(Math.random() * (upper - lower)) + lower;
    },
    sleep: function(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    }
  }
};
</script>

<style lang="css">
#dice-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  margin-bottom: 1em;
}

#dice-wrap h3 {
  text-align: center;
  margin: 1em 0 0.5em;
}

.dice-types {
  width: 50%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.display-die,
.display-mod {
  width: 2.7em;
  height: 2.7em;
  margin: 0.3em;
  font-size: 18px;
  border: none;
  border-radius: 100%;
  background: #e3e3e3;
  transition: 0.05s;
}

.display-die:focus {
  outline: none;
}

.display-die:active {
  background: #c3c3c3;
}

.dice-modfiers {
  margin-bottom: 1em;
}

.display-mod:focus {
  outline: none;
}

#selected-dice-mod {
  background: #c3c3c3;
}

.lineup {
  width: 90%;
  height: 2em;
  margin-top: 0.7em;
  font-size: 24px;
}

.roll-dice {
  width: 4em;
  height: 4em;
  padding: 1em;
  background: #73c482;
  color: white;
  font-size: 24px;
  border: none;
  border-radius: 100%;
  transition: 0.05s;
}

.roll-dice:focus {
  outline: none;
}

.roll-dice:active {
  background: rgb(80, 167, 96);
}
</style>